import React from 'react'

import {
  AlignItems,
  Box,
  Col,
  Color,
  Display,
  FontWeight,
  Grid,
  Space,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { CONTROL_DISCOUNT_VALUES } from '../boxPricesConfig'

type DiscountPerWeekNDDProps = {
  discountValues?: string[]
}

export const DiscountPerWeekNDD = ({
  discountValues = CONTROL_DISCOUNT_VALUES,
}: DiscountPerWeekNDDProps) => {
  const discountBoxes = [
    'Today',
    '2nd box',
    '3rd box',
    '4th box',
    '5th box',
    '6th box',
    '7th box',
    '8th box',
  ]

  const tiles = discountBoxes.slice(0, discountValues.length)
  // Mobile shows four tiles per row; a final row of two starts at column 4 so it sits centred
  const centredTileIndex = tiles.length % 4 === 2 ? tiles.length - 2 : -1

  return (
    <Box display={Display.Flex} data-testid="discount-per-week-ndd">
      <Grid columnGap={2}>
        {tiles.map((box, index) => (
          <Col
            key={box}
            gridColumn={[
              index === centredTileIndex ? '4 / span 3' : 'auto / span 3',
              index === centredTileIndex ? '4 / span 3' : 'auto / span 3',
              'auto / span 2',
              'auto / span 2',
            ]}
          >
            <Box>
              <Box
                bg={box !== 'Today' ? Color.ColdGrey_500 : Color.Primary_600}
                borderRadius={1.5}
                width="64px"
                height="64px"
                display={Display.Flex}
                alignItems={AlignItems.Center}
              >
                <Text
                  size={5}
                  color={Color.White}
                  fontWeight={FontWeight.Bold}
                  textAlign={TextAlign.Center}
                >
                  {discountValues[index]}
                </Text>
              </Box>

              <Space size={1} />

              <Text size={2} color={Color.ColdGrey_800} textAlign={TextAlign.Center}>
                {box}
              </Text>
              <Space size={2} />
            </Box>
          </Col>
        ))}
      </Grid>
    </Box>
  )
}
